import logException from './log-exception';
import configuration from '../configuration';

export default function formatUrl(address: string) {
  let parsedUrl = null;
  try {
    parsedUrl = new URL(address);
  } catch (e) {
    void logException(e, `formatUrl received an invalid url: ${address}`);
    throw new Error(`formatUrl received an invalid url: ${address}`);
  }

  if (configuration.enable_vehicle_selection_step) {
    parsedUrl.pathname = 'vehicle-selection/';
    parsedUrl.searchParams.set('estimatePayment', '1');
    parsedUrl.searchParams.set('source', configuration.cta_type ?? '');
  }

  // set partner & theme
  if (configuration.partner?.partner_identifier) {
    parsedUrl.searchParams.set('partner', configuration.partner.partner_identifier);
  } else {
    void logException(new Error('no partner identifier could be set!'));
  }
  parsedUrl.searchParams.set('appTheme', configuration.appTheme);
  if (configuration.dealer_identifier) {
    parsedUrl.searchParams.set('dealership', configuration.dealer_identifier);
  }
  if (configuration.partner_google_tag_id) {
    parsedUrl.searchParams.set('partnerGId', configuration.partner_google_tag_id);
  }
  if (configuration.show_estimate_payment_step) {
    parsedUrl.searchParams.set('estimatePayment', '1');
  }
  // We don't add this parameter for other flows
  if (configuration.flow_type === 'lead_first') {
    parsedUrl.searchParams.set('flow', 'lead-first');
  } else if (configuration.flow_type === 'long_prequal') {
    parsedUrl.searchParams.set('flow', 'long-prequal');
  } else if (configuration.flow_type === 'digital_credit_app') {
    parsedUrl.searchParams.set('flow', 'digital-credit-app');
  }

  // Temporary until we fix issues in new Two Step flow
  if (configuration.partner?.name === 'Cycle Trader') {
    parsedUrl.searchParams.set('flow', 'two-step');
  }

  // Update search with new queryParams
  return parsedUrl.toString();
}
